/** Theme-aligned stat cards for Hiring dashboard. */

const colorClasses = {
  blue: "border-[hsl(var(--ds-primary)/0.35)] hover:border-[hsl(var(--ds-primary))] from-[hsl(var(--ds-primary)/0.06)] to-[hsl(var(--ds-surface))]",
  green:
    "border-[hsl(var(--ds-success)/0.35)] hover:border-[hsl(var(--ds-success))] from-[hsl(var(--ds-success)/0.06)] to-[hsl(var(--ds-surface))]",
  emerald:
    "border-[hsl(var(--ds-success)/0.35)] hover:border-[hsl(var(--ds-success))] from-[hsl(var(--ds-success)/0.06)] to-[hsl(var(--ds-surface))]",
  purple:
    "border-[hsl(var(--ds-secondary)/0.35)] hover:border-[hsl(var(--ds-secondary))] from-[hsl(var(--ds-secondary)/0.06)] to-[hsl(var(--ds-surface))]",
  orange:
    "border-[hsl(var(--ds-warning)/0.4)] hover:border-[hsl(var(--ds-warning))] from-[hsl(var(--ds-warning)/0.08)] to-[hsl(var(--ds-surface))]",
  indigo:
    "border-[hsl(var(--ds-primary)/0.35)] hover:border-[hsl(var(--ds-primary))] from-[hsl(var(--ds-primary)/0.06)] to-[hsl(var(--ds-surface))]",
  yellow:
    "border-[hsl(var(--ds-warning)/0.4)] hover:border-[hsl(var(--ds-warning))] from-[hsl(var(--ds-warning)/0.08)] to-[hsl(var(--ds-surface))]",
  red: "border-[hsl(var(--ds-danger)/0.35)] hover:border-[hsl(var(--ds-danger))] from-[hsl(var(--ds-danger)/0.06)] to-[hsl(var(--ds-surface))]",
  amber:
    "border-[hsl(var(--ds-warning)/0.4)] hover:border-[hsl(var(--ds-warning))] from-[hsl(var(--ds-warning)/0.08)] to-[hsl(var(--ds-surface))]",
  teal: "border-[hsl(var(--ds-primary)/0.35)] hover:border-[hsl(var(--ds-primary))] from-[hsl(var(--ds-primary)/0.06)] to-[hsl(var(--ds-surface))]",
  cyan: "border-[hsl(var(--ds-info)/0.35)] hover:border-[hsl(var(--ds-info))] from-[hsl(var(--ds-info)/0.06)] to-[hsl(var(--ds-surface))]",
  rose: "border-[hsl(var(--ds-danger)/0.35)] hover:border-[hsl(var(--ds-danger))] from-[hsl(var(--ds-danger)/0.06)] to-[hsl(var(--ds-surface))]",
};

const valueColors = {
  blue: "text-[hsl(var(--ds-primary))]",
  green: "text-[hsl(var(--ds-success))]",
  emerald: "text-[hsl(var(--ds-success))]",
  purple: "text-[hsl(var(--ds-secondary))]",
  orange: "text-[hsl(var(--ds-warning-fg))]",
  indigo: "text-[hsl(var(--ds-primary))]",
  yellow: "text-[hsl(var(--ds-warning-fg))]",
  red: "text-[hsl(var(--ds-danger))]",
  amber: "text-[hsl(var(--ds-warning-fg))]",
  teal: "text-[hsl(var(--ds-primary))]",
  cyan: "text-[hsl(var(--ds-info))]",
  rose: "text-[hsl(var(--ds-danger))]",
};

export default function StatCard({ label, value, color = "blue", onClick, hint, compact = true }) {
  const interactive = typeof onClick === "function";
  const Wrapper = interactive ? "button" : "div";

  const pad = compact ? "p-2" : "p-4";
  const labelCls = compact ? "text-[11px] leading-tight" : "text-sm";
  const valueCls = compact ? "text-xl" : "text-3xl";
  const hintCls = compact ? "text-[9px] mt-0.5" : "text-[10px] mt-2";

  return (
    <Wrapper
      type={interactive ? "button" : undefined}
      onClick={onClick}
      title={interactive ? hint || "Click to view details" : undefined}
      className={`bg-gradient-to-br rounded-xl ${colorClasses[color] || colorClasses.blue} border ${
        compact ? "border" : "border-2"
      } ${pad} text-left w-full min-w-0 transition-all ${
        interactive
          ? "cursor-pointer hover:shadow-sm focus:outline-none focus:ring-1 focus:ring-[hsl(var(--ds-ring))]"
          : ""
      }`}
    >
      <div className={`font-medium text-[hsl(var(--ds-muted-fg))] mb-0.5 truncate ${labelCls}`}>
        {label}
      </div>
      <div
        className={`font-bold leading-none ${valueCls} ${
          valueColors[color] || valueColors.blue
        }`}
      >
        {value}
      </div>
      {interactive && !compact ? (
        <div className={`text-[hsl(var(--ds-muted-fg))] uppercase tracking-wide ${hintCls}`}>
          {hint || "Click to view details"}
        </div>
      ) : null}
    </Wrapper>
  );
}
